import NZContact from "../../../components/NZComponent/home/NZContact/NZContact";
import { useNavigate } from "react-router";
import PETROLModels from "../../../components/NZComponent/NzPetrol/PETROLModels";
import HighLevelSpecs from "../../../components/NZComponent/NzPetrol/HighLevelSpecs";
import NZNZPetrolGregFarrier from "../../../components/NZComponent/NzPetrol/NZNZPetrolGregFarrier";
import NZElectricaTV from "../../../components/NZComponent/NzPetrol/NZElectricaTV";
import HomeIcon from "../../../assets/svg/HomeIcon.svg";
import RightSideArrow from "../../../assets/svg/RightSideArrow.svg";
import NZGregFarrier from "../../../components/NZComponent/home/NZGregFarrier/NZGregFarrier";
import NZGregAssociates from "../../../components/NZComponent/home/NZGregAssociates/NZGregAssociates";
import NZPetrolFeatures from "../../../components/NZComponent/NzPetrol/NZPetrolFeatures";
import NZPetrolModels from "../../../components/NZComponent/NzPetrol/NZPetrolModels";
import NZPetrolSafety from "../../../components/NZComponent/NzPetrol/NZPetrolSafety";
import NZPetrolSpec from "../../../components/NZComponent/NzPetrol/NZPetrolSpec";
import PETROLSIDE from "../../../assets/images/1000EFIImg/1000EFInewdoors2.jpg";
import SEOMetadata from "../../../components/SEOMetadata";
import { seoConfig } from "../../../config/seoConfig";
import NZPetrolFAQ from "../../../components/NZComponent/NzPetrol/NZPetrolFAQ";

const NzPetrol = () => {
  const seoData = seoConfig.nz.petrol;
  let navigate = useNavigate();

  return (
    <>
      <SEOMetadata
        title={seoData.title}
        description={seoData.description}
        keywords={seoData.keywords}
      />
      <div>
        <div className="px-[12px] py-[6px] bg-[#F0F0F0] flex items-center">
          <img
            src={HomeIcon}
            alt="HomeIcon"
            className="cursor-pointer"
            onClick={() => navigate("/")}
          />
          <div className="flex items-center mx-[5px]">
            <img src={RightSideArrow} alt="RightSideArrow" />
            <img src={RightSideArrow} alt="RightSideArrow" />
          </div>
          <div className="text-[14px] leading-[24px] text-[#383838] montserrat-semi-bold">{`Petrol`}</div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-[20px] md:gap-[30px] lg:gap-[26px]">

          <div className=" md:h-[670px] w-full">
            <div className="w-full h-auto lg:h-[100%] xl:h-[100%]">
              <img
                src={PETROLSIDE}
                alt="Petrol Tuatara 1000 EFI side-by-side utility vehicle"
                className="w-full h-full object-cover border border-black"
              />
            </div>


          </div>
          <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }} className="
     px-[20px]
  sm:px-[30px]
  lg:px-[50px]
pb-[20px]">

            <h1
              className="text-white kuunari-bold 
  text-[20px] 
  md:text-[40px] 
  lg:text-[50px]  
  xl:text-[65px]  
  leading-[32px]
  md:leading-[42px] 
  lg:leading-[62px]
  mb-[11px] 
  text-center 
  max-w-[100%] md:max-w-[511px] lg:max-w-[650px]

  mx-auto"
              style={{ textShadow: "2px 4px 6px #000000" }}
            >
              Petrol Tuatara 1000 EFI Side-by-Side UTV
            </h1>

            <p className="my-[20px] md:my-[30px] lg:my-[35px]
text-[#666666] md:text-[20px] text-[16px] leading-[26px] text-center montserrat-medium">
              The Tuatara ATV / UTV 1000 EFI is a well-tested design that has
              been around for over 12 years With its powerful 1000cc car engine,
              and equipped with 4WD and differential lock on both axles this
              side-by-side UTV can pretty much go wherever you point it. The
              Tuatara 1000 EFI is also equipped with a 50 litre fuel tank, and
              given the engine’s amazing economy, most operators are only
              refuelling once a week. And the towing and carrying capacity has
              to be seen to be believed.
            </p>

            <div className="text-center flex items-center justify-center flex-wrap">
              {/* <button className="bg-[#78C15A]  px-[30px] text-white leading-[40px] text-[16px] m-[10px]">
                Phone Now
              </button> */}
              <button
                className="bg-[#6FBF4A] text-white px-6 py-3 font-semibold uppercase hover:opacity-90 transition"
                onClick={() => navigate("/nz/ContactUs")}
              >
                CONTACT US
              </button>
            </div>
          </div>
        </div>

        <div>
          {/* <PETROLModels /> */}
          <NZPetrolFeatures />
          <NZPetrolModels />
          <NZPetrolSafety />
          <div className="bg-white py-[40px]">
            <div className="max-w-[1200px] mx-auto px-[20px]">
              <h3 className="text-[28px] kuunari-bold text-center mb-[20px]">
                Key Benefits of the Tuatara 1000 EFI
              </h3>

              <ul className="grid md:grid-cols-2 gap-4 text-[#666] text-[16px]">
                <li>✔ Heavy-duty UTV designed for farm and commercial work</li>
                <li>✔ Certified ROPS and seat belts for passenger safety</li>
                <li>✔ Powerful and fuel-efficient 1000cc EFI engine</li>
                <li>✔ Excellent off-road capability with 4WD</li>
                <li>✔ Large cargo deck and strong towing capacity</li>
              </ul>
            </div>
          </div>

          <NZPetrolSpec />
          {/* <HighLevelSpecs />
          <NZNZPetrolGregFarrier />
          <NZElectricaTV /> */}
        </div>

        <NZGregFarrier
          bg={"#fff"}
          slogan="“THIS IS HANDS DOWN THE MOST VERSATILE ATV I HAVE PURCHASED FOR THE FARM.”"
        />
        <NZPetrolFAQ />
        <div id="contact-form">
          <NZContact />
        </div>
        {/* <NZGregAssociates /> */}
      </div>
    </>
  );
};
export default NzPetrol;
